(() => {
  'use strict';
  // Browse links land at the collection filters/products, below the sticky header.
  const header = document.getElementById('SiteHeader');
  const updateBrowseOffset = () => {
    document.documentElement.style.setProperty('--parts-browse-offset', `${(header?.offsetHeight || 0) + 16}px`);
  };
  const scrollToBrowse = () => {
    if (location.hash !== '#CollectionAjaxContent') return;
    updateBrowseOffset();
    document.getElementById('CollectionAjaxContent')?.scrollIntoView({ block: 'start', behavior: 'instant' });
  };
  updateBrowseOffset();
  if (header && window.ResizeObserver) new ResizeObserver(updateBrowseOffset).observe(header);
  window.addEventListener('resize', updateBrowseOffset);
  window.addEventListener('hashchange', scrollToBrowse);
  window.addEventListener('load', () => requestAnimationFrame(scrollToBrowse));
  document.addEventListener('click', event => {
    const browse = event.target.closest('a[data-browse]');
    if (!browse || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const disclosure = browse.closest('details');
    if (disclosure) disclosure.open = false;
    browse.closest('.drawer')?.querySelector('.js-drawer-close')?.click();
  });
  // The app inserts and refreshes its control asynchronously. Keep its real
  // click handler, with a concise label and equivalent keyboard activation.
  document.querySelectorAll('.tax-banner').forEach(banner => {
    const formatRequest = () => {
      banner.querySelectorAll('[tax-exemption-request-button-label]').forEach(label => {
        if (label.textContent !== 'Request tax exemption') label.textContent = 'Request tax exemption';
      });
      banner.querySelectorAll('[tax-exemption-request-button]').forEach(button => {
        button.setAttribute('role', 'button');
        button.setAttribute('tabindex', '0');
        button.setAttribute('aria-label', 'Request tax exemption');
      });
    };
    formatRequest();
    new MutationObserver(formatRequest).observe(banner, { childList: true, subtree: true });
    banner.addEventListener('keydown', event => {
      const button = event.target.closest('[tax-exemption-request-button]');
      if (button && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault(); button.click();
      }
    });
  });
  // Explicit draft context also survives copied navigation/search links.
  const draft = window.Shopify?.theme?.role !== 'main' && window.Shopify?.theme?.id;
  if (draft) {
    document.querySelectorAll('.discovery-nav a, .discovery-mobile-shortcuts a').forEach(link => {
      const url = new URL(link.href);
      if (url.origin === location.origin) { url.searchParams.set('preview_theme_id', String(draft)); link.href = url.href; }
    });
    document.querySelectorAll('[data-discovery-search]').forEach(form => {
      const input = document.createElement('input'); input.type = 'hidden'; input.name = 'preview_theme_id'; input.value = String(draft); form.append(input);
    });
  }
  document.addEventListener('keydown' , event => {
    if (event.key !== 'Escape') return;
    const nav = event.target.closest('.discovery-nav');
    if (!nav) return;
    const group = event.target.closest('details[open]');
    if (group) { group.open = false; group.querySelector(':scope > summary').focus(); event.preventDefault(); }
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.discovery-nav--desktop > details[open], .discovery-nav--desktop > div > details[open]').forEach(group => {
      if (!group.contains(event.target)) group.open = false;
    });
  });
})();
